import { clsxm } from '@app/styles/clsxm';

// TODO refactor - add more common classes based on usage, rounded by default (smaller round on mobile)
// TODO refactor - there are redundant rounded-xl for "xl:" modifier
export const Container: React.FC<{ className?: string; rounded?: boolean }> = ({ children, rounded, className }) => {
  return <div className={clsxm('bg-white px-5 py-6', rounded && 'rounded-xl', className)}>{children}</div>;
};
